export const LogisticsSavedTypes = [
  Object.freeze({
    id: " ",
    name: "All",
  }),
  Object.freeze({
    id: "1",
    name: "Saved",
  }),
  Object.freeze({
    id: "0",
    name: "NotSaved",
  }),
];

export const getLogisticsSavedTypesIdByName = (name) => {
  return (
    LogisticsSavedTypes.find((x) => x.name === name)?.id ||
    ""
  );
};

export const getLogisticsSavedTypesNameById = (id) => {
  return (
    LogisticsSavedTypes.find((x) => x.id === id)?.name ||
    ""
  );
};

export const getLogisticsSavedTypesById = (id) => {
  return LogisticsSavedTypes.find((x) => x.id === id) || "";
};
